import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { CorrectScoreHeaderButtonTabs } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { TabBarItem } from '@frontend/sports/web/tab-bar-utils';

import { CorrectScoreOptionGroupToggleViewService } from './correct-score-option-group-toggle-view.service';

@Component({
    selector: 'ms-toggle-view-button',
    templateUrl: './toggle-view-button.component.html',
    styleUrls: ['./toggle-view-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleViewButtonComponent implements OnInit {
    sitecore = inject(Sitecore);
    private correctScoreOptionGroupToggleViewService = inject(CorrectScoreOptionGroupToggleViewService);

    buttonTabs: TabBarItem<string>[];

    ngOnInit(): void {
        this.buttonTabs = Object.entries(this.sitecore.event)
            .filter(
                ([id]) => id === CorrectScoreHeaderButtonTabs.CorrectScoreRegularView || id === CorrectScoreHeaderButtonTabs.CorrectScoreCompactView,
            )
            .map(([id, title]) => ({ id, title, active: id === this.correctScoreOptionGroupToggleViewService.currentViewId() }));
    }

    onTabClick(event: MouseEvent, id: string) {
        this.buttonTabs = this.buttonTabs.map((item) => {
            return { ...item, active: item.id === id };
        });

        this.correctScoreOptionGroupToggleViewService.setCorrectScoreView(id);

        event.stopPropagation();
        event.preventDefault();
    }
}
